import { combineReducers } from 'redux';
import { actionTypes, sliceKeys } from './constants';
import { reducer as companies } from './companies';
import { reducer as cities } from './cities';
import { reducer as houses } from './houses';
import { reducer as rooms } from './rooms';
import { reducer as relatedRooms } from './relatedRooms';
import { reducer as desks } from './desks';
import { reducer as create } from './acceptanceCreate';
import { reducer as attachmentsFilter } from './attachmentsFilter';

const reducers = {
  [sliceKeys.companies]: companies,
  [sliceKeys.cities]: cities,
  [sliceKeys.houses]: houses,
  [sliceKeys.rooms]: rooms,
  [sliceKeys.relatedRooms]: relatedRooms,
  [sliceKeys.desks]: desks,
  [sliceKeys.createPage]: create,
  [sliceKeys.attachmentsFilter]: attachmentsFilter,
};

const combinedReducer = combineReducers(reducers);

export const reducer = (state, action) => {
  const nextState = combinedReducer(state, action);

  if (action.type === actionTypes.houseDeselected) {
    const hasSelectedHouses =
      nextState[sliceKeys.houses].housesModel.houses.size > 0;

    if (!hasSelectedHouses) {
      nextState[sliceKeys.rooms] = rooms(nextState[sliceKeys.rooms], {
        type: actionTypes.roomStateReset,
      });
    }
  }

  return nextState;
};
